import { Loader2 } from "lucide-react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

/**
 * Loading shell used while page data is fetched.
 *
 * Renders the full site header and footer so the server-rendered HTML always
 * contains outgoing internal links — pages that showed a bare spinner looked
 * like crawl "dead ends" to search engines.
 */
const PageLoading = ({ label = "Loading…" }: { label?: string }) => (
  <div className="min-h-screen bg-background flex flex-col">
    <Helmet>
      <title>Garden-Review | UK Garden Tool Reviews &amp; Advice</title>
      <meta
        name="description"
        content="Independent UK reviews of garden tools and machinery, plus practical growing advice from the Garden-Review team."
      />
    </Helmet>
    <Header />
    <main className="flex-1 flex items-center justify-center py-24">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{label}</p>
      </div>
    </main>
    <Footer />
  </div>
);

export default PageLoading;
